import LandingReveal from '@/modules/Pages/shared/LandingReveal';

export default function ProofSection() {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-10">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-5">
            See what&apos;s behind the risk
          </h2>
        </LandingReveal>

        <LandingReveal delayClass="landing-delay-1">
          <div className="landing-screenshot-frame rounded-2xl overflow-hidden bg-dark-gray-b">
            <img
              src="/images/actions1.png"
              alt="ChurnSignal account risk detail with drivers and recommended response"
              className="w-full object-contain"
            />
            <div className="px-6 py-4 border-t border-light bg-surface-subtle">
              <p className="text-sm text-secondary text-center">
                Product view — risk surfaced, change explained, recommended response for a single account.
              </p>
            </div>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
